import angular from 'angular';
import * as Sentry from "@sentry/browser";
import { Angular as AngularIntegration } from "@sentry/integrations";
import angularLoadingBar from 'angular-loading-bar';
import angularVsRepeat from 'angular-vs-repeat/dist/angular-vs-repeat';
import angularAutoheight from 'autoheight/src/angular-autoheight';
import restangular from 'restangular';
import checklistModel from 'checklist-model';
import 'angular-animate';
import 'angular-cookies';
import 'angular-sanitize';
import 'ngsticky';
import 'ngstorage';
import 'angular-file-upload';
import 'angular-http-auth';
import '@uirouter/angularjs';
import 'ment.io';
import 'ng-elif';
import 'angularjs-scroll-glue';
import './components/extensions/register-headroom'; // eslint-disable-line import/order
import 'headroom.js/dist/angular.headroom';
import 'angular-sortable-view/src/angular-sortable-view';
import 'ng-slide-down';
import 'angular-gettext';
import { environment, isProduction } from '@sdk/config/appConfig';

import '../lang/bin/angular_pl_PL';
import '../lang/bin/angular_en_US';
import './components/extensions/christmas-theme';
import './components/extensions/symbols';
import './components/extensions/clone';
import './components/extensions/closest';
import './components/extensions/focus';
import './components/extensions/find';
import './ui-bootstrap/ui-bootstrap-custom-tpls-2.5.0';
import './components/extensions/nested-ui-bootstrap-dropdown';
import './assets/bootstrap-style.less';
import './assets/less/shared.less';
import './assets/less/style.less';
import common from './common';
import components from './components';
import onboarding from './onboarding';
import manage from './dashboard/manage';
import newsfeed from './newsfeed';
import shifts from './shifts';
import menu from './menu';
import users from './users';
import laborCost from './labor-cost';
import reports from './reports';
import timeclock from './timeclock';
import account from './account';
import settings from './settings';
import config from './config';
import appRun from './app.run';
import configureCalendarSdk from './configureCalendarSdk';
import appConfig from './app.config';
import tasksModule from './tasks';
import shiftTasksModule from './shiftTasks';
import messagesModule from './messages';
import educationModule from './education';
import dashboardModule from './dashboard';
import rosterModule from './roster';
import memoryLeaksDiagnostics from './memory-leaks-diagnostics';
import integrations from './integrations';
import rateModule from './rate/index';
import feedbackModule from './feedback/index';

if (__TEST__) {
  global.regeneratorRuntime = window.regeneratorRuntime;
}

let slingDependencies = [
  restangular,
  checklistModel,

  'ui.router',
  'ui.bootstrap',
  'ngStorage',
  'ngCookies',
  'ngSanitize',
  'angularFileUpload',
  'http-auth-interceptor',
  'elif',
  'gettext',

  common,
  components,
  onboarding,
  dashboardModule,
  rosterModule,
  manage,
  newsfeed,
  messagesModule,
  shifts,
  tasksModule,
  shiftTasksModule,
  menu,
  users,
  educationModule,
  laborCost,
  reports,
  timeclock,
  account,
  settings,
  integrations,
  rateModule,
  feedbackModule,
];

if (!__TEST__) {
  slingDependencies = [
    ...slingDependencies,
    angularLoadingBar,
    angularVsRepeat,
    angularAutoheight,
    'luegg.directives',
    'ng-slide-down',
    'sticky',
    'headroom',
    'ngAnimate',
    'angular-sortable-view',
    'nested-ui-bootstrap-dropdown',
  ];
}

if (__MEMORY_LEAKS_DIAGNOSTICS__ && __DEV__) {
  slingDependencies.push(memoryLeaksDiagnostics);
}

if (config.SENTRY_DSN && !__TEST__) {
  if (isProduction) {
    // In production we only send explicitly-dispatched captureMessage /
    // captureException calls. Automatic capture (the Angular $exceptionHandler
    // hook, window.onerror, unhandled rejections) is disabled because it
    // previously blew through our Sentry error budget.
    Sentry.init({
      dsn: config.SENTRY_DSN,
      environment: environment,
      defaultIntegrations: false,
    });
  } else {
    // Preproduction keeps full auto-capture via the Angular integration.
    Sentry.init({
      dsn: config.SENTRY_DSN,
      integrations: [new AngularIntegration()],
      environment: environment,
    });
    slingDependencies.push('ngSentry');
  }
}

angular.module('sling', slingDependencies).constant('PrintConfig', {});

if (__TEST__) {
  angular
    .module('sling')
    .config((RestangularProvider, $sceDelegateProvider) => {
      RestangularProvider.setRestangularFields({ selfLink: 'self.link', route: '_route' });

      const whitelist = $sceDelegateProvider.resourceUrlWhitelist();
      whitelist.push('https://w.soundcloud.com/**');
      $sceDelegateProvider.resourceUrlWhitelist(whitelist);
    })
    .config((RestangularProvider) => {
      RestangularProvider.addFullRequestInterceptor(
        (data, method, element, url, params, headers, httpConfig) => {
          RestangularProvider.setFullResponse(Boolean(httpConfig && httpConfig.fullResponse));
        }
      );
    })
    .run(($rootScope, $q, Authentication, Restangular, ModalStack) => {
      Restangular.setBaseUrl(config.API_END_POINT);
      $rootScope.authentication = Authentication;
      global.Promise = $q;
      ModalStack.init();
    })
    .run(configureCalendarSdk);
} else if (window.location.href.indexOf('file://') !== 0) {
  angular.module('sling').config(appConfig).run(configureCalendarSdk).run(appRun);
  angular.bootstrap(document.documentElement, ['sling'], { strictDi: true });
}
